var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmallBusinesses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FFE8F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 23v0c-1.78 0-2.43-2.28-1.708-3.907L16 13h16l2.703 6.081C35.444 20.75 34.825 23 33 23v0m-18 0v12h6m-6-12c1 0 2-1 2-1m16 1v12h-6m6-12c-1 0-1.219-.61-2-1M21 35v-8h6v8m-6 0h6M17 22v-2m0 2s1 1 2.5 1 2.5-1 2.5-1m0 0v-2m0 2s1.127 1 2 1 2-1 2-1m0 0v-2m0 2s.5 1 2.5 1c1.5 0 1.712-1 2.5-1m0 0v-2",
    stroke: "#E11C9C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiNGRkU4RjciLz4KPHBhdGggZD0iTTE1IDIzVjIzQzEzLjIyMDEgMjMgMTIuNTY5MiAyMC43MTkzIDEzLjI5MjEgMTkuMDkyOEwxNiAxM0gzMkwzNC43MDI5IDE5LjA4MTRDMzUuNDQ0IDIwLjc0OSAzNC44MjQ5IDIzIDMzIDIzVjIzTTE1IDIzQzE1IDI3LjY4NjMgMTUgMzUgMTUgMzVIMjFNMTUgMjNDMTYgMjMgMTcgMjIgMTcgMjJNMzMgMjNDMzMgMjcuNjg2MyAzMyAzNSAzMyAzNUgyN00zMyAyM0MzMiAyMyAzMS43ODEgMjIuMzkwNSAzMSAyMk0yMSAzNVYyN0gyN1YzNU0yMSAzNUgyN00xNyAyMlYyME0xNyAyMkMxNyAyMiAxOCAyMyAxOS41IDIzQzIxIDIzIDIyIDIyIDIyIDIyTTIyIDIyVjIwTTIyIDIyQzIyIDIyIDIzLjEyNjggMjMgMjQgMjNDMjQuODczMiAyMyAyNiAyMiAyNiAyMk0yNiAyMlYyME0yNiAyMkMyNiAyMiAyNi41IDIzIDI4LjUgMjNDMzAgMjMgMzAuMjEyNSAyMiAzMSAyMk0zMSAyMkMzMSAyMS4yMTkgMzEgMjAgMzEgMjAiIHN0cm9rZT0iI0UxMUM5QyIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgSmallBusinesses as ReactComponent };